var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 509,
    viewBox: "0 0 668 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449.364 251.521H203.095C201.42 247.333 199.074 237.114 203.095 229.742C207.116 222.371 219.848 218.853 225.712 218.015C222.082 215.502 215.272 201.509 225.712 189.404C234.381 179.352 252.796 182.555 260.893 185.347C259.497 180.6 262.023 168.965 272.075 164.275C284.64 158.411 292.444 167.198 297.749 171.106C299.983 161.334 312.157 143.129 342.982 148.49C367.567 152.766 375.371 175.295 372.3 185.347C374.534 179.204 401.911 171.106 425.91 185.347C454.767 202.47 457.182 235.606 449.364 251.521Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.003 277.354H379.297C372.875 272.887 361.873 260.937 369.245 248.874C376.616 236.811 399.679 236.588 410.29 237.985C417.828 230.725 427.545 217.549 446.308 219.56C465.072 221.57 474.788 239.66 472.276 248.874C476.185 247.478 485.845 247.031 493.217 256.413C500.588 265.795 490.145 274.283 484.003 277.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.248 355.415L166.319 299.219L272.401 402.447L271.248 355.415Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.238 329.256L166.319 299.219L271.248 355.415L301.238 329.256Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.777 402.009L240.195 381.763L253.286 369.258C254.471 368.125 256.42 368.498 257.103 369.989L271.777 402.009Z",
    fill: "#D6E4FF",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.128 404.132L165.695 298.781L255.269 367.571L216.128 404.132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.429 406.355C277.104 417.524 288.329 439.694 319.824 439.024C351.32 438.354 360.31 425.342 360.869 418.92C362.544 412.777 362.209 399.152 347.466 393.791C329.038 387.09 324.933 406.983 327.363 413.057C329.038 417.245 331.551 429.809 365.895 444.887C393.37 456.949 420.9 442.095 431.231 433.16",
    stroke: "black",
    strokeWidth: 2.38571,
    strokeDasharray: "7.16 7.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorNoResult);
export default __webpack_public_path__ + "static/media/VectorNoResult.fd6d18ca0c21f4b18f602ad04c485ae8.svg";
export { ForwardRef as ReactComponent };